import React from "react";

/**
 * Renders one or more JSON-LD schema objects as <script type="application/ld+json">.
 * Because this is inline JSX (not a useEffect DOM injection), react-snap captures
 * the tags in the pre-rendered HTML output — non-JS crawlers see the schema on
 * first byte.
 *
 * Usage:
 *   <SchemaMarkup schema={organizationSchema()} />
 *   <SchemaMarkup schema={[orgSchema, breadcrumbSchema(items), faqPageSchema(faqs, url)]} />
 */
export default function SchemaMarkup({ schema }) {
  if (!schema) return null;
  const list = Array.isArray(schema) ? schema.filter(Boolean) : [schema];
  if (list.length === 0) return null;
  return (
    <>
      {list.map((s, i) => (
        <script
          key={`schema-${i}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(s) }}
        />
      ))}
    </>
  );
}
